import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { WriteBacksPage } from "~/pages/writebacks-page";

export const Route = createFileRoute("/_dashboard/$datasetSlug/apps/syncs/writebacks")({
  validateSearch: z.object({ writeBackId: z.uuid().optional() }),
  component: WriteBackRoute,
});

function WriteBackRoute() {
  const { datasetSlug } = Route.useParams();
  const { writeBackId } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <WriteBacksPage
      datasetSlug={datasetSlug}
      selectedWriteBackId={writeBackId ?? null}
      onOpenWriteBack={(nextWriteBackId) => {
        void navigate({ search: (previous) => ({ ...previous, writeBackId: nextWriteBackId }) });
      }}
      onCloseWriteBack={() => window.history.back()}
    />
  );
}
